<template>
	<div class="chang-title">
		<div @click="clickTitleIcon" class="icon">
      <svg class="burgertoogle" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" style="fill: rgb(17, 17, 17);">
        <line :class="top" x1="0" y1="10" x2="30" y2="10" stroke="#111111" stroke-width="1"></line>
        <line class="mid" x1="0" y1="15" x2="25" y2="15" stroke="#111111" stroke-width="1"></line>
        <line class="bot" x1="0" y1="20" x2="30" y2="20" stroke="#111111" stroke-width="1"></line>
      </svg>
		</div>
		<div class="chang-logo"></div>
		<div class="search-icon">
			<i class="bri-icon-xingtaiduICON_sousuo--"></i>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	
	let changline = true

	export default {
		data() {
			return {
				top: ""
			}
		},
		methods: {
			clickTitleIcon() {
				this.$emit('clickIcon')
				if(changline) {
					this.linetoright()
					changline = !changline
				} else {
					this.linetoleft()
					changline = !changline
				}
			},
			linetoright(){
				this.top = "normal"
			},
			linetoleft(){
				this.top = "move"
			}
		},
		components: {
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"
	@import "~common/stylus/minxin"

	.chang-title
		position: relative
		height: 40px
		margin: 10px 0
		.icon
			position: fixed
			display: block
			left: 20px
			top: 8px
			z-index: 350
			.burgertoogle
				display: block
				line
					transition: all 0.5s ease
		.search-icon
			position: absolute
			right: 30px
			top: 13px
			width: 60px
			height: 18px
			.bri-icon-xingtaiduICON_sousuo--
				float: right
				font-size: $font-web-small
				color: #ddd
				line-height: 18px
				margin-right: 3px
		.chang-logo
			background: url(./logo@2x.png)
			width: 130px
			height: 40px
			background-repeat: no-repeat
			margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/common/chang-title/chang-title.vue